<div class="qb-page container-fluid mt-2">
  <header class="qb-header">
    <div class="qb-header__copy">
      <h1 class="qb-title">Today's Queue Board</h1>
      <p class="qb-subtitle">
        Live view for reception and staff — who is waiting, with the doctor, paused, or done.
      </p>
    </div>
    <div class="qb-header__context">
      <app-work-context-bar [compact]="true" />
    </div>
    <div class="qb-header__meta">
      <span class="qb-refresh-pill" *ngIf="lastRefreshedAt">
        <i class="pi pi-sync" aria-hidden="true"></i>
        Updated {{ lastRefreshedAt | date: 'shortTime' }}
      </span>
      <button type="button" class="qb-refresh-btn" (click)="loadBoard()" [disabled]="loading">
        Refresh
      </button>
    </div>
  </header>

  <div class="qb-board" *ngIf="cards.length > 0; else emptyBoard">
    <section class="qb-column" *ngFor="let column of columns">
      <header class="qb-column__head">
        <h2 class="qb-column__title">{{ column.label }}</h2>
        <span class="qb-column__count">{{ columnCount(column.key) }}</span>
      </header>

      <div class="qb-column__body">
        <article class="qb-card" *ngFor="let card of cardsForColumn(column.key)">
          <div class="qb-card__top">
            <span class="qb-card__name">{{ card.name }}</span>
            <span class="qb-card__time">{{ formatTime(card.time) }}</span>
          </div>
          <div class="qb-card__meta">
            <span class="qb-card__chip" *ngIf="card.patient_number">
              {{ card.patient_number }}
            </span>
            <span class="qb-card__wait" *ngIf="formatWaiting(card)">
              Waiting {{ formatWaiting(card) }}
            </span>
          </div>
        </article>

        <div class="qb-column__empty" *ngIf="columnCount(column.key) === 0">
          No patients
        </div>
      </div>
    </section>
  </div>

  <ng-template #emptyBoard>
    <div class="qb-empty">
      <i class="pi pi-users" aria-hidden="true"></i>
      <h2>No patients in today's queue</h2>
      <p>Select clinic and doctor above, or check back when patients check in.</p>
    </div>
  </ng-template>
</div>
